import './locales/register'
import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'

const DepartmentDashboard = lazy(
    () => import('./components/DepartmentDashboard')
)
const DashboardModule: RouteObject = {
    path: '',
    children: [
        {
            path: '',
            element: <DepartmentDashboard />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default DashboardModule
